import { SlidersHorizontal } from 'lucide-react'
import {
  IDENTITY_ADJUSTMENTS,
  NodeKind,
  TransformKind,
  assertAdjustmentsParams,
  isIdentityAdjustments,
  type AdjustmentsParams,
} from '@/core/document'
import { AdjustmentsPanel } from '@/tools/adjustments/AdjustmentsPanel'
import { ToolKind, ToolTab, type TransformTool } from '@/tools/types'

export const ADJUSTMENTS_TOOL: TransformTool = {
  kind: ToolKind.Transform,
  tab: ToolTab.Adjust,
  transforms: [TransformKind.Adjustments],
  definitions: {
    [TransformKind.Adjustments]: {
      createDefault: () => ({ ...IDENTITY_ADJUSTMENTS }),
      summarize: (params: AdjustmentsParams) => {
        assertAdjustmentsParams(params)
        return isIdentityAdjustments(params) ? '' : 'adjusted'
      },
    },
  },
  label: 'Adjust',
  icon: SlidersHorizontal,
  appliesTo: (node) => node?.kind === NodeKind.Image,
  Panel: AdjustmentsPanel,
}
